var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "waves",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 24 150 40",
    preserveAspectRatio: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "gentle-wave",
    d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "moving-waves"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: -1,
    fill: "rgba(251,251,251,0.40"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 3,
    fill: "rgba(251,251,251,0.35)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 5,
    fill: "rgba(251,251,251,0.25)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 8,
    fill: "rgba(251,251,251,0.20)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 13,
    fill: "rgba(251,251,251,0.15)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 16,
    fill: "rgba(251,251,251,0.95"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.4c7b95b54fcfda2ed1e9d61f0d838598.svg";
export { ForwardRef as ReactComponent };